/**
 * makes lodash available as underscore in webpack
 * (necessary for backbone)
 */
module.exports = require('lodash');
